import { RiPencilFill as Edit } from '@remixicon/react';

import { ButtonIcon, ButtonIconProps } from '@spotify-internal/encore-web';

export type EditButtonProps = Omit<
  ButtonIconProps<'tertiary'>,
  'aria-label' | 'children' | 'variant'
>;

export const EditButton = ({ size = 'small', ...props }: EditButtonProps) => {
  return (
    <ButtonIcon
      variant="tertiary"
      size={size}
      aria-label="Edit"
      data-track-id="button.edit"
      data-track-action="open-dialog"
      {...props}
    >
      <Edit aria-hidden />
    </ButtonIcon>
  );
};
